import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Theme } from "../theme";
import { renderToStaticMarkup } from "react-dom/server";
import { CheckIcon } from "./icons/CheckIcon";

const Input = styled.input.attrs({ type: "checkbox" })`
    position: absolute;
    opacity: 0;
    height: 0;
    width: 0;
`;

const CheckMark = styled.span`
    position: absolute;
    top: 1px;
    left: 2px;
    height: 18px;
    width: 18px;
    border: 1px solid ${Theme.colors.text_dark_gray};
    background-color: ${Theme.colors.gray[400]};

    &:after {
        content: "";
        position: absolute;
        display: none;
    }
`;

const ChildrenContainer = styled.div`
    color: #595959;
    font-size: 12px;
    min-height: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

const Container = styled.label`
    display: block;
    position: relative;
    padding-left: 35px;
    user-select: none;
    background-color: white;

    input:checked ~ span {
        /* border: 2px solid ${Theme.colors.blue}; */
        &:after {
            display: block;
        }
    }

    input:focus-visible ~ ${CheckMark} {
        outline: 3px solid ${Theme.colors.cyan};
    }
`;

export const DisabledCheckBox = React.forwardRef(({ value, children, ...props }, ref) => {
    return (
        <Container>
            <Input value={value} {...props} ref={ref} />
            <CheckMark color={value} />
            <ChildrenContainer>
                <div>{children}</div>
            </ChildrenContainer>
        </Container>
    );
});

DisabledCheckBox.propTypes = {
    /**
     * Input value of the checkbox.
     */
    value: PropTypes.string,
    /**
     * Children nodes or label.
     */
    children: PropTypes.node,
};
